import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "last-completed",
  "data-test": "last-completed"
}


import { timeDiffFromNow } from "@/helpers";

interface Props {
  lastCompleted: string;
  text: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LastCompleted',
  props: {
    lastCompleted: {},
    text: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.text) + " " + _toDisplayString(_unref(timeDiffFromNow)(__props.lastCompleted, _ctx.$t)), 1))
}
}

})